// Default imports
import React, { useState } from "react";

import ContainerWide from "../components/ContainerWide";
import HubspotFormModal from "../components/HubspotFormModal";

import NewsletterBgLines from "../images/newsletter-bg-desktop-lines.svg";

import { getNewsletterCompData } from "../data/components-newsletter.data";
import { Container } from "react-bootstrap";

const HUBSPOT_NEWSLETTER_FORM_ID = "206c878f-3d39-46e6-bbc4-008f5ff9d508";

const Newsletter = ({ fullWidth, pageTitle, variant }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalSessionId, setModalSessionId] = useState(0);
    const compData = getNewsletterCompData();
    const { header } = compData.wp.mdaThemeOptions.themeSettings.newsletter;

    const handleModalOpen = () => {
        setModalSessionId((sessionId) => sessionId + 1);
        setIsModalOpen(true);
    };

    return (
        <>
            <ContainerWide
                className={`newsletter ${
                    variant ? `-${variant}` : ""
                } -full-width`}
            >
                <div className="newsletter__bg">
                    <NewsletterBgLines className="newsletter__bg-lines" />
                </div>
                <Container className="newsletter__wrapper">
                    <div className="newsletter__copy">
                        {variant === "dark" && (
                            <p className="newsletter__kicker">Newsletter</p>
                        )}
                        <p className="newsletter__title">{header}</p>
                    </div>
                    <button
                        type="button"
                        className="newsletter__button"
                        onClick={handleModalOpen}
                    >
                        Join the Wyden Newsletter
                    </button>
                </Container>
            </ContainerWide>
            <HubspotFormModal
                key={modalSessionId}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                pageTitle={pageTitle || "Newsletter"}
                header="Join the Wyden Newsletter"
                description="Get company news, product updates and insights delivered to your inbox."
                formId={HUBSPOT_NEWSLETTER_FORM_ID}
                eyebrow="Newsletter"
                trackingEventName="Newsletter Form: Submitted"
            />
        </>
    );
};

export default Newsletter;
